/** A ProcessedModel or Dataset routeLong as an S3 prefix. A few rows were saved without the trailing slash. */
export const withTrailingSlash = (routeLong: string): string =>
  routeLong.endsWith("/") ? routeLong : `${routeLong}/`;
